import { defineStore } from "pinia";

import publicApi from "@/auth/publicApi";


export const useSysTypo =
  defineStore(
    "sysTypo",
    {
      state: () => ({
        activeTypography: null,
        loading: false,
        loaded: false,
        error: null
      }),


      getters: {

        typographyStyles: state =>
          state.activeTypography || {},

        sectionTypography() {
          return {
            h1:
              this.h1TypographyStyle,

            h2:
              this.h2TypographyStyle,

            h3:
              this.h3TypographyStyle,

            body:
              this.bodyTypographyStyle,

            small:
              this.smallTypographyStyle,

            caption:
              this.captionTypographyStyle,

            button:
              this.buttonTypographyStyle,

            input:
              this.inputTypographyStyle,

            label:
              this.labelTypographyStyle
          };
        },


        baseFontFamily() {

          const typo =
            this.typographyStyles;

          const primary =
            typo.fontFamily ||
            "Roboto";

          const secondary =
            typo.secondaryFontFamily;

          const fallback =
            typo.fontFallback ||
            "Arial, Helvetica, sans-serif";

          if (secondary) {
            return `${primary}, ${secondary}, ${fallback}`;
          }

          return `${primary}, ${fallback}`;
        },


        h1TypographyStyle() {

          const typo =
            this.typographyStyles;

          return {
            fontFamily:
              this.baseFontFamily,

            fontStyle:
              typo.fontStyle ||
              "normal",

            fontSize:
              `${typo.h1FontSize || 32}px`,

            fontWeight:
              typo.h1FontWeight ||
              700,

            lineHeight:
              typo.h1LineHeight ||
              1.2,

            letterSpacing:
              `${typo.h1LetterSpacing || 0}px`
          };
        },


        h2TypographyStyle() {

          const typo =
            this.typographyStyles;

          return {
            fontFamily:
              this.baseFontFamily,

            fontStyle:
              typo.fontStyle ||
              "normal",

            fontSize:
              `${typo.h2FontSize || 28}px`,

            fontWeight:
              typo.h2FontWeight ||
              700,

            lineHeight:
              typo.h2LineHeight ||
              1.25,

            letterSpacing:
              `${typo.h2LetterSpacing || 0}px`
          };
        },


        h3TypographyStyle() {

          const typo =
            this.typographyStyles;

          return {
            fontFamily:
              this.baseFontFamily,

            fontStyle:
              typo.fontStyle ||
              "normal",

            fontSize:
              `${typo.h3FontSize || 24}px`,

            fontWeight:
              typo.h3FontWeight ||
              600,

            lineHeight:
              typo.h3LineHeight ||
              1.3,

            letterSpacing:
              `${typo.h3LetterSpacing || 0}px`
          };
        },


        bodyTypographyStyle() {

          const typo =
            this.typographyStyles;

          return {
            fontFamily:
              this.baseFontFamily,

            fontStyle:
              typo.fontStyle ||
              "normal",

            fontSize:
              `${typo.bodyFontSize || 16}px`,

            fontWeight:
              typo.bodyFontWeight ||
              400,

            lineHeight:
              typo.bodyLineHeight ||
              1.5
          };
        },


        smallTypographyStyle() {

          const typo =
            this.typographyStyles;

          return {
            fontFamily:
              this.baseFontFamily,

            fontStyle:
              typo.fontStyle ||
              "normal",

            fontSize:
              `${typo.smallFontSize || 14}px`,

            fontWeight:
              typo.fontWeight ||
              400
          };
        },


        captionTypographyStyle() {

          const typo =
            this.typographyStyles;

          return {
            fontFamily:
              this.baseFontFamily,

            fontStyle:
              typo.fontStyle ||
              "normal",

            fontSize:
              `${typo.captionFontSize || 12}px`,

            fontWeight:
              typo.fontWeight ||
              400
          };
        },


        buttonTypographyStyle() {

          const typo =
            this.typographyStyles;

          return {
            fontFamily:
              this.baseFontFamily,

            fontStyle:
              typo.fontStyle ||
              "normal",

            fontSize:
              `${typo.buttonFontSize || 14}px`,

            fontWeight:
              typo.buttonFontWeight ||
              500
          };
        },


        inputTypographyStyle() {

          const typo =
            this.typographyStyles;

          return {
            fontFamily:
              this.baseFontFamily,

            fontStyle:
              typo.fontStyle ||
              "normal",

            fontSize:
              `${typo.inputFontSize || 16}px`,

            fontWeight:
              typo.fontWeight ||
              400
          };
        },


        labelTypographyStyle() {

          const typo =
            this.typographyStyles;

          return {
            fontFamily:
              this.baseFontFamily,

            fontStyle:
              typo.fontStyle ||
              "normal",

            fontSize:
              `${typo.labelFontSize || 14}px`,

            fontWeight:
              typo.fontWeight ||
              400
          };
        }
      },


      actions: {

        async loadActiveTypography(
          force = false
        ) {

          if (
            this.loaded &&
            !force
          ) {
            return this.activeTypography;
          }

          this.loading = true;
          this.error = null;

          try {

            const response =
              await publicApi.get(
                "/system-typography-configurations/active"
              );

            this.activeTypography =
              response.data || {};

            this.loaded = true;

            return this.activeTypography;
          }
          catch (error) {

            console.error(
              "Failed to load active system typography configuration.",
              error
            );

            this.error = error;

            return null;
          }
          finally {

            this.loading = false;
          }
        }
      }
    }
  );